import nuxtStorage from 'nuxt-storage';
import hosts from '../data/hosts.json'
import { defineStore } from 'pinia'
import { useRoute, useRouter } from 'vue-router'
const router = useRouter()
export const languagesDefault = [
  { flag: 'es', language: 'es', title: 'Español' }
  // ,
  // { flag: 'en', language: 'en', title: 'English' },
  // { flag: 'ca', language: 'ca', title: 'Catalá' },
  // { flag: 'eu', language: 'eu', title: 'Euskera' },
  // { flag: 'fr', language: 'fr', title: 'French' },
  // { flag: 'de', language: 'de', title: 'Deutsch' },
  // { flag: 'nl', language: 'nl', title: 'Dutch' },
  // { flag: 'pl', language: 'pl', title: 'Polish' },
  // { flag: 'no', language: 'no', title: 'Norwegian' },
  // { flag: 'ro', language: 'ro', title: 'Romanian' }
]

export const useStore = defineStore('store', {
  state: () => ({
    api_url: "",
    host: "",
    TITULO: "",
    NOTARIA: null,
    VIEWMODEL: {},
    ModoAccesible: false,
    token: null,
    user: null,
    idioma: "es",
    languages: null,
    css_list: null,
    RecaptchaGroups: [null, '6LcoRlklAAAAAE3SgHyos1jSBhRG-NvwKESOy3MT', '6Ld6r1QpAAAAAKECU6jo-xhLRHsnu_2ofmOS5v4W', '6Lep4lQpAAAAAP-mTLTamzilYsfiByuPs-Q1GsAj', '6Lcg41QpAAAAAMQ2wDYA9ryclG3RIYLcXHG6lu63','6LdRkr0rAAAAAKRmvtwZlA1_jFEQ2CA7CgelyG99'],
    recaptchaSiteKey: null,
  }),
  actions: {
    async initNotaria(headers: any) {
      try {
        //const route = useRoute()
        if (headers && headers.host) {
          //console.log(new Date())
          console.log("initNotaria ");
          //console.log('Environment')
          //console.log(process.env.NODE_ENV)
          //console.log(process.env.NUXT_ENV_API_URL)
          this.host = headers.host
          //console.log('headers')
          //console.log(JSON.stringify(headers))

          // debugger
          if (process.env.NODE_ENV === 'development') {
            this.api_url = process.env.NUXT_ENV_API_URL
          } else {
            this.api_url = 'https://' + this.host + '/'
          }

          //console.log('backend: ' + this.api_url)
        }

        //Seleccionamos la notaría según el host
        var id = 23; //Notaría por defecto     
        hosts.map((h) => {
          if (h.hosts.includes(this.host)) {
            id = h.id;
          }
        });

        //console.log('idNotaria: ' + id)
        var res;
        var idioma: string = this.idioma && this.idioma != "es" ? "_" + this.idioma : "";
        var dataurl = ""
        if (process.env.NODE_ENV === "development") {
          dataurl = this.api_url +
            "appdata/" +
            id +
            "/data/notaria" +
            idioma +
            ".json?v=" +
            Date.now()
        } else {
          dataurl = this.api_url + "appdata/data/notaria" + idioma + ".json?v=" + Date.now()
        }
        console.log("dataurl: " + dataurl)
        if (this.NOTARIA) {
          if (this.NOTARIA.Languaje != this.idioma) {
            res = await $fetch(dataurl)
          }
        } else {
          res = await $fetch(dataurl)
        }

        if (res) {
          this.NOTARIA = res;
          this.TITULO = this.NOTARIA.Nombre;
          if (this.NOTARIA.Personalizar.RecaptchaGroup) {
            this.recaptchaSiteKey = this.RecaptchaGroups[this.NOTARIA.Personalizar.RecaptchaGroup]
          }
        }
        await this.loadcssjs(id);
        await this.loadLanguages(id);
        await this.initLogin();

        //Se configura en el panel de control
        // await dispatch('getReviews')
      } catch (e) {

      }

      return id
    },

    async FecthModoAccesible() {
      var r = eval(typeof window !== 'undefined' ? nuxtStorage.localStorage.getData("ModoAccesible") : false);
      this.ModoAccesible = r;
    },
    async toggleModoAccesible() {
      nuxtStorage.localStorage.setData("ModoAccesible", !this.ModoAccesible);
      this.ModoAccesible = !this.ModoAccesible;
    },
    async setIdioma(v: any) {
      this.idioma = v;
    },
    async initLogin() {
      this.token = typeof window !== 'undefined' ? nuxtStorage.localStorage.getData("token") : null;
    },

    getReviews() {
      //console.log("Entra en getReviews");

      const url = `https://maps.googleapis.com/maps/api/place/details/json?placeid=ChIJw4xGRQiBYw0Rj66sxkqopA0&key=AIzaSyCzggys0LtiRm_d97j6ud0m2l6khuYzqq4`;

      useFetch(url)
        .then((response) => {
          // Procesa la respuesta para obtener las reseñas
          const reviews = response.data.result.reviews;
          //console.log(reviews);
        })
        .catch((error) => {
          console.error("Error al obtener las reseñas:", error);
          //console.log(error.response.data.error);
        });
    },
    async loadcssjs(id: any) {
      var timestamp = new Date().getTime();
      //inyectar css
      var url_css_dev = this.api_url + "appdata/" + id + "/static/";
      var url_css_prod = this.api_url + "appdata/static/";
      var url_css =
        process.env.NODE_ENV === "development" ? url_css_dev : url_css_prod;
      var css = [
        "header.css",
        //"home-banner.css",
        // "home-blog.css",
        // "home-pn.css",
        //"home-servicios.css",
        "home-testimonios.css",
        "blog.css",
        // "servicios.css",
        //"form.css",
        "footer.css",
        "notarios.css",
        // "team.css",
        // "contacto.css",
        "gallery.css",
        "home-gallery.css"
      ];
      var csslist: Array<string> = []
      if (this.NOTARIA.Personalizar.CustomCSS !== "") css.push("custom.css");


      css.forEach(c => {
        csslist.push(url_css + c + "?v=" + timestamp)
      })
      this.css_list = csslist

    },
    async loadLanguages(id: any) {
      console.log("loadLanguages")
      var langaugeUrl
      if (process.env.NODE_ENV === "development") {
        langaugeUrl = this.api_url +
          "appdata/" +
          id +
          "/data/idiomasNotaria.json?v=" +
          Date.now()
      } else {
        console.log(this.api_url);
        langaugeUrl = this.api_url + "appdata/data/idiomasNotaria.json?v=" + Date.now()

      }
      console.log(langaugeUrl)
      var res = await $fetch(langaugeUrl)
      if (res) {
        this.languages = res.Idiomas
      } else {
        this.languages = languagesDefault
      }
      //this.CreateDynamicLanguagesRoutes()
    },


    /**
     * Crea routas dinámicas según los idiomas disponibles
     */
    // CreateDynamicLanguagesRoutes() {
    //   console.log("CreateDynamicLanguagesRoutes")   
    //   const rutas = this.router.getRoutes()
    //   this.languages.forEach(lang => {
    //     if (lang.language != 'es') {
    //       rutas.forEach(ruta => {
    //         var r = { ...ruta }
    //         r.path = "/" + lang.Language + ruta.path
    //         r.name = lang.Language + '-' + ruta.name
    //         console.log('adding route ' + r.name + ' ' + r.path)
    //         this.router.addRoute(r)
    //       })
    //     }
    //   })
    // },


    /**
     * Realiza el login del usuario
     * @param userLogin Objeto con los datos de login {username,password}
     */

    async doLogin(userLogin: any) {
      var loginUrl = ""
      if (process.env.NODE_ENV === 'development') {
        loginUrl = this.api_url + 'api/authentication'
      } else {
        loginUrl = 'https://controlpanel.notin.es/api/authentication'
      }

      var result = await $fetch(loginUrl, { method: "POST", body: userLogin, headers: { 'Content-Type': 'application/json' } })
      if (result) {
        this.token = result;
        var tokenparsed = this.parseJwt(result)

        this.user = tokenparsed.user
        nuxtStorage.localStorage.setData('token', this.token);
        nuxtStorage.localStorage.setData('user', tokenparsed.user);
        var user = JSON.parse(tokenparsed.user)
        if (user.Notarias.includes(this.NOTARIA.id))
          return true;
        else
          return false;
      } else {
        return false;
      }
    },
    async doLogOut() {
      this.token = null;
      this.user = null;
      nuxtStorage.localStorage.setData('token', null);
      nuxtStorage.localStorage.setData('user', null);
    },
    parseJwt(token: string) {
      if (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
      } else {
        alert('Falló la autenticación, necesita un usuario');
      }
    }
  },
  getters: {
    getIdioma: (state) => {
      const store = useStore()
      return store.idioma
    },
    getFlag: (state) => {
      const store = useStore()
      var lang = store.languages ? store.languages.find((x: any) => x.Language === store.idioma) : null
      return lang ? lang.Flag : "es"
    }
  }
})
